import React from "react";
export const AboutTitle = React.createContext();
